// extracted by mini-css-extract-plugin
module.exports = {"header":"header___2HeyG","imgBox":"imgBox___2Un7y","title":"title___XRB-z","mechanics":"mechanics___1sThf","hideGoHome":"hideGoHome___3CvxZ","hideGoBack":"hideGoBack___3uTF9"};